import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";

export default function useCourse(){

    const {course} = useParams();

    const queryClient = useQueryClient();

    return queryClient.getQueryData(course);
}